import {distance} from '@turf/turf';
import {every, isEmpty, map, min, reduce} from 'underscore';
import turf from '@turf/turf';

import Coordinate from 'common/types/Coordinate';

export const closestAddress = (singleAddress, addresses) => {
  const options = map(addresses, address => {
    const addressPosition = address.position;
    const dist = distance(
      new Coordinate(singleAddress.position.lat, singleAddress.position.lng).toGeoJSON(),
      new Coordinate(addressPosition.lat, addressPosition.lng).toGeoJSON()
    ) * 1000; // convert to meters
    return {address, dist};
  });
  return min(options, ({dist}) => dist);
};

export const parseGeometry = (geometry) => {
  const feature = turf.feature(geometry);
  return feature === null ? null : feature.geometry;
};

export const checkCoords = (coords, geometry) => {
  const point = turf.point([coords.lng, coords.lat]);
  const feature = turf.feature(geometry);
  return turf.inside(point, feature);
};

// Combines a list of geometries into a single geoJSON feature.
export const combineGeometries = (geometries) => {
  const feature = reduce(geometries, (memo, geometry) => {
    const feature = turf.feature(geometry);
    if (memo === null) return feature;
    return turf.union(memo, feature);
  }, null);

  return feature === null ? null : feature.geometry;
};

// Combines a list of regions into a single geoJSON feature. A region is a object with a geometry
// property that is a geoJSON Polygon or MultiPolygon. An optional list of Coordinates can be
// passed. combineRegions will filter our regions that do not contain ALL coordinates.
export const combineRegions = (regions, coords = []) => {
  if (isEmpty(regions)) return null;

  const points = map(coords, (coord) => turf.point([coord.lng, coord.lat]));

  const feature = reduce(regions, (memo, region) => {
    const feature = turf.feature(region.geometry);
    const valid = every(points, (p) => turf.inside(p, feature));
    if (!valid) return memo;
    if (memo === null) return feature;
    return turf.union(memo, feature);
  }, null);

  return feature === null ? null : feature.geometry;
};

export const rideDirections = (origin, destination) => {
  const result = {
    pickup: origin,
    dropoff: destination,
    origin,
    originDistance: 0,
    destination,
    destinationDistance: 0,
  };

  return result;
};



// WEBPACK FOOTER //
// ./src/common/utils/geo.js